module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('team.acceptInvitation')) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.confirmed) ? _c('h4', [_vm._v(_vm._s(_vm.$t('team.confirmed')) + " "), _c('router-link', {
    attrs: {
      "to": _vm.project.crowdfunding ? ("/crowdfunding/" + (_vm.project.id) + "/" + (_vm.project.title)) : ("/fundraising/" + (_vm.project.id) + "/" + (_vm.project.title))
    }
  }, [_vm._v(_vm._s(_vm.project.title))])], 1) : _c('h4', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1880608"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/AcceptTeamInvitation.vue
// module id = 839
// module chunks = 1